const AudienceCookie = () => {
  // Function to set cookie with expiration date
  function setCookie(name, value, days) {
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + days);
    document.cookie = `${name}=${value}; expires=${expiryDate.toUTCString()}; path=/`;
  }

  // Function to get URL parameters
  function getUrlParameter(name) {
    const regex = new RegExp(`[?&]${name}=([^&#]*)`);
    const results = regex.exec(window.location.search);
    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  // Function to handle audience cookie setting
  function SetAudienceCookie(developmentId, audienceId) {
    const cookieName = `audience_id_${developmentId}`;
    setCookie(cookieName, audienceId, 30); // Set cookie for 30 days
  }

  // Function to update page content
  function updatePageContent(developmentId) {
    // Example: Update an element with a new class or content
    $('.content-switch-trigger').each(function () {
      if ($(this).data('development-id') === developmentId) {
        $(this).addClass('content-switch-trigger--active');
      }
    });
  }

  // Check for audience parameter and set cookie if present
  const audienceParam = getUrlParameter('audience');
  const developmentParam = getUrlParameter('development_id');

  if (audienceParam && developmentParam) {
    SetAudienceCookie(developmentParam, audienceParam);
    updatePageContent(developmentParam, audienceParam); // Ensure content is updated
  }

  // jQuery document ready function to handle button clicks
  jQuery(document).ready(function ($) {
    $('.content-switch-trigger__button').on('click', function (event) {
      event.preventDefault(); // Prevent default anchor behavior

      const developmentId = $(this).data('development-id');
      const audienceId = $(this).data('audience-id');
      const audienceOther = $(this).data('audience-other');

      // Set cookie and reload page with URL parameters
      const url = new URL(window.location.href);
      url.searchParams.set('development_id', developmentId);
      url.searchParams.set('audience', audienceId);
      url.searchParams.set('audience-other', audienceOther);

      // Set the cookie
      SetAudienceCookie(developmentId, audienceId, audienceOther);

      // Reload the page with new URL
      window.location.href = url.toString();
    });
  });
};

export default AudienceCookie;
